import type { PropsWithChildren } from 'react'
import { cn } from '@/src/utils/styles'

interface ErrorInlineProps {
  className?: string
  variant?: 'danger' | 'primary' | 'warning'
}

export function ErrorInline({
  className,
  children,
  variant = 'danger',
}: PropsWithChildren<ErrorInlineProps>) {
  return (
    <span
      data-testid='error-line'
      className={cn('text-sm', className, {
        'text-danger-text': variant === 'danger',
        'text-primary': variant === 'primary',
        'text-warning-text': variant === 'warning',
      })}
    >
      {children}
    </span>
  )
}
